import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation('layout')

  return (
    <div className="footer footer-transparent d-print-none">
      <div className="container">
        <Row className="text-center align-items-center flex-row-reverse">
          {/* Right side, add links when needed */}
          <Col lg="auto" className="ms-lg-auto">
            <ul className="list-inline list-inline-dots mb-0">
              {/*<li className='list-inline-item'>*/}
              {/*  <a target='_blank' href='https://headwayapp.co/geartrack-updates' className='link-secondary'>Changelog</a>*/}
              {/*</li>*/}
            </ul>
          </Col>
          <Col xs={12} lg="auto" className="mt-3 mt-lg-0">
            <ul className="list-inline list-inline-dots mb-0">
              <li className="list-inline-item">© 2016 - {new Date().getFullYear()} Geartrack</li>
              <li className="list-inline-item">
                <Link to="/terms-and-conditions" className="link-secondary">
                  {t('footer.terms')}
                </Link>
              </li>
              <li className="list-inline-item">
                <Link to="/privacy-policy" className="link-secondary">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li className="list-inline-item">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://headwayapp.co/geartrack-updates"
                  className="link-secondary"
                >
                  {t('footer.changelog')}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Footer
